export class ViwAreeModel {
  desArea: string
  flgDelete: boolean
  idArea: number
  numFdv: number
  uuid: string
}